import { useTranslation } from 'react-i18next';
import { resources } from '../../../resources/resources';

export default function CompanyInfo() {
  const { t: translate } = useTranslation();

  return (
    <div className="footer-company footer-nav">
      <ul>
        <li>
          <span>{translate(resources.company.cUI)}</span>
        </li>
        <li>
          <span>{translate(resources.company.oNRC)}</span>
        </li>
        <li>
          <span>{translate(resources.company.cAEN)}</span>
        </li>
        <li>
          <span>{translate(resources.company.address)}</span>
        </li>
      </ul>
    </div>
  );
}
